// Messages feature — query-key gyár + a lista-szűrő típusa. A tényleges hívásokat a route a tipizált
// ts-rest kliensen (`api.messages.query`) intézi; a kulcsok itt élnek (cache-egységesítés). A
// `@atlas/contracts` a szerződés forrás-igazsága — itt csak kulcs-logika van (a meetings minta).

/** A lista-lekérdezés szűrői (a query-kulcs része — szűrő-/rendezés-váltás új cache-bejegyzést nyit).
 *  A `q` a szabad-szöveg (tárgy/tartalom), a `type` a típus-szűrő (internal/external), az `order` a fix
 *  kiküldés-dátum (sentAt|createdAt) rendezés iránya (a legacy default: DESC). */
export interface MessageListFilters {
  q: string;
  type: string;
  order: 'asc' | 'desc';
}

/** Query-kulcs gyár — a lista- + detail- + refs-cache egységes címzése (a write-vertikum invalidál rájuk). */
export const messageKeys = {
  all: ['messages'] as const,
  lists: () => ['messages', 'list'] as const,
  list: (filters: MessageListFilters) => ['messages', 'list', filters] as const,
  details: () => ['messages', 'detail'] as const,
  detail: (id: string) => ['messages', 'detail', id] as const,
  refs: () => ['messages', 'refs'] as const,
  /** Egy üzenet melléklet-listája (a panel gazdája; a feltöltés/törlés ezt invalidálja). */
  attachments: (id: string) => ['messages', 'attachments', id] as const,
};
